import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ErrorInterface } from '../error/error.interface';
import { LabelInterface } from '../label/label.interface';

@Component({
  selector: 'app-datepicker-input',
  templateUrl: './datepicker-input.component.html',
  styleUrls: ['./datepicker-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatepickerInputComponent),
      multi: true,
    },
  ],
})
export class DatepickerInputComponent {
  @Input()
  public className: string;

  @Input()
  public error: ErrorInterface;

  @Input()
  public id: string;

  @Input()
  public label: LabelInterface;

  @Input()
  public max: Date;

  /**
   * @example yyyy-mm-dd
   */
  @Input()
  public min: Date;

  @Input()
  public name: string;

  private val: string;

  public get value(): string {
    return this.val;
  }

  public set value(val: string) {
    this.val = val;
    this.onChange(this.val);
  }

  public writeValue(value: string) {
    this.val = value;
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  private onChange = (val: string) => {};
  private onTouched = () => {};
}
